import { useEffect, useRef } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Importer les styles CSS de Leaflet
import 'leaflet/dist/leaflet.css';

// Correction du problème d'icônes par défaut de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Footer = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  

  useEffect(() => {
    // Attendre que l'élément DOM soit disponible
    if (!mapRef.current) return;

    try {
      // Coordonnées de Casablanca
      const position = [33.57301694744741, -7.638284422408982];

      // Créer la carte
      const map = L.map(mapRef.current).setView(position, 15);

      // Ajouter le layer OpenStreetMap
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      // Ajouter un marqueur
      L.marker(position)
        .addTo(map)
        .bindPopup('<b>Adawall Maroc</b><br>Nous sommes ici !')
        .openPopup(); 

      // Stocker l'instance de la carte
      mapInstanceRef.current = map;

      console.log('Carte OpenStreetMap créée avec succès');

    } catch (error) {
      console.error('Erreur lors de la création de la carte :', error);
    }

    // Cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
      }
    };
  }, []);

  return (
    <footer className='footer'>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        maxWidth: '1200px',
        margin: '0 auto',
        flexWrap: 'wrap',
        gap: '32px',
      }}>
        {/* Colonne 1 : Réseaux sociaux */}
        <div style={{ flex: '1', minWidth: '220px', padding: '0 20px'}}>
          <h4>Adawall Maroc</h4>
          
          <p>Adawall Maroc, représentant exclusif d'Adawall, sublime vos intérieurs avec des revêtements muraux haut de gamme</p>

          <div style={{ display: 'flex', gap: '16px', marginTop: '12px' , textAlign: 'center' }}>
            <a href="https://www.facebook.com/profile.php?id=61577622317866" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="fa-facebook-f" size={28} style={{ transition: 'color 0.2s' }} />
            </a>
            <a href="https://www.instagram.com/adawall_maroc/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="fa-instagram" size={28} style={{ transition: 'color 0.2s' }} />
            </a>
            <a href="https://www.linkedin.com/company/adawall-maroc/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="fa-linkedin-in" size={28}  style={{ transition: 'color 0.2s' }} />
            </a>
          </div>
        </div>

        {/* Colonne 2 : Accès rapide */}
        <div style={{ flex: '1', minWidth: '220px', padding: '0 20px', color: '#F5F5F4' }}>
          <h4>Accès rapide</h4>
          <ul style={{ listStyle: 'none', padding: 0, marginTop: '12px', lineHeight: '2' }}>
            <li><a href="/collections/papierpeint">Papier peints</a></li>
            <li>
              <Link to="/#categories-section">Produits</Link>
            </li>    
            <li><a href="/projets">Projets</a></li>
                <li><a href="/a-propos">À propos</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

        {/* Colonne 3 : OpenStreetMap */}
        <div style={{ flex: '1', minWidth: '220px', padding: '0 20px' }}>
          <h4>Retrouvez-nous ici</h4>
          <div className="footer-map">
            <div
              ref={mapRef}
              style={{
                height: '180px',
                width: '320px', 
                maxWidth: '100%',
                margin: '12px auto',
                border: '1px solid #ccc',
                display: 'block'
              }}
            />
          </div>
          <div style={{ marginTop: '10px', fontSize: '0.95em' }}>
            📍 Rue Racine Valfleuri MAARIF Casablanca<br />
            📞 +212 664 66 46 92<br />
            📧 contact@adawall.ma
              <br />
            <a
              href="https://www.google.com/maps/place/Adawall+Maroc-+papier+peint+casablanca/@33.5730056,-7.6389319,19z/data=!3m1!4b1!4m6!3m5!1s0xda7d329306b4fa9:0x2fe7abd4c530c535!8m2!3d33.5730045!4d-7.6382882!16s%2Fg%2F11vt65x5vl?entry=ttu&g_ep=EgoyMDI1MDcyMS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="google-maps-link"
            >
              Voir sur Google Maps
            </a>
          </div>
        </div>
      </div>

      {/* Copyright en bas au centre */}
      <div style={{
        textAlign: 'center',
        marginTop: '32px',
        paddingBottom: '18px',
        color: '#F5F5F4',
        fontSize: '0.95em',
        letterSpacing: '1px',
      }}>
        © 2025 Adawall Maroc. Tous droits réservés.
      </div>
    </footer>
  );
};

export default Footer;